import styled from 'styled-components';

export const ServicesContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow: hidden;
`;

export const FloatingElement = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  background: linear-gradient(45deg, rgba(197, 51, 123, 0.1), rgba(233, 30, 99, 0.1));
  border-radius: 50%;
  filter: blur(40px);
  animation: float ${props => props.delay || '0s'} 6s ease-in-out infinite;
  top: ${props => Math.random() * 80 + 10}%;
  left: ${props => Math.random() * 80 + 10}%;
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
  }
`;

export const MainContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

export const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #2B3857;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #2B3857, #C5337B);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #64748B;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const Form = styled.form`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
`;

export const FormSection = styled.div`
  margin-bottom: 2.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2B3857;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #E2E8F0;
`;

export const InputGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const Label = styled.label`
  display: block;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #C5337B;
    box-shadow: 0 0 0 3px rgba(197, 51, 123, 0.1);
  }
  
  &::placeholder {
    color: #9CA3AF;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
  resize: vertical;
  min-height: 100px;
  
  &:focus {
    outline: none;
    border-color: #C5337B;
    box-shadow: 0 0 0 3px rgba(197, 51, 123, 0.1);
  }
  
  &::placeholder {
    color: #9CA3AF;
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
`;

export const ServiceCard = styled.div`
  background: #F8FAFC;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #C5337B;
    box-shadow: 0 4px 12px rgba(197, 51, 123, 0.1);
  }
`;

export const ServiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ServiceTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  color: #2B3857;
  margin: 0;
`;

export const ServiceActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ActionButton = styled.button`
  background: ${props => props.variant === 'danger' ? '#EF4444' : '#C5337B'};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.variant === 'danger' ? '#DC2626' : '#A02A63'};
    transform: translateY(-1px);
  }
`;

export const BulletPointsContainer = styled.div`
  margin-top: 1rem;
`;

export const BulletPoint = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const BulletInput = styled.input`
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  font-size: 0.9rem;
  margin-left: 0.5rem;
  
  &:focus {
    outline: none;
    border-color: #C5337B;
    box-shadow: 0 0 0 2px rgba(197, 51, 123, 0.1);
  }
`;

export const AddServiceButton = styled.button`
  background: #C5337B;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  margin-top: 1rem;
  
  &:hover {
    background: #A02A63;
    transform: translateY(-1px);
  }
`;

export const SubmitButton = styled.button`
  background: linear-gradient(135deg, #C5337B, #E91E63);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  width: 100%;
  margin-top: 2rem;
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(197, 51, 123, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ErrorMessage = styled.div`
  background: #FEF2F2;
  border: 1px solid #FECACA;
  color: #DC2626;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SuccessMessage = styled.div`
  background: #F0FDF4;
  border: 1px solid #BBF7D0;
  color: #16A34A;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const PreviewSection = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const PreviewTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2B3857;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const PreviewCard = styled.div`
  background: #F8FAFC;
  border-radius: 12px;
  padding: 2rem;
`;

export const PreviewContent = styled.div`
  text-align: center;
`;

export const PreviewServices = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const PreviewService = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #E2E8F0;
  text-align: left;
`;

export const PreviewServiceTitle = styled.h4`
  font-size: 1.2rem;
  font-weight: 600;
  color: #2B3857;
  margin-bottom: 0.5rem;
`;

export const PreviewServiceDescription = styled.p`
  color: #64748B;
  margin-bottom: 1rem;
  line-height: 1.5;
`;

export const PreviewBulletPoints = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 1rem;
`;

export const PreviewBulletPoint = styled.li`
  color: #374151;
  margin-bottom: 0.5rem;
  padding-left: 1.5rem;
  position: relative;
  
  &:before {
    content: "•";
    color: #C5337B;
    font-weight: bold;
    position: absolute;
    left: 0;
  }
`;

export const PreviewButton = styled.button`
  background: #C5337B;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #A02A63;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: #64748B;
`;

export const EmptyStateIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
`;

export const EmptyStateText = styled.p`
  font-size: 1.1rem;
  margin: 0;
`;
